import {Injectable} from '@angular/core';
import {AppConfigService, OidcAuth, TokenType} from '@proleis/proleis-web-app';
import {LoginResponse, OidcSecurityService} from 'angular-auth-oidc-client';
import {Observable, of} from 'rxjs';
import {exhaustMap, shareReplay} from 'rxjs/operators';

@Injectable()
export class OidcAuthMethod extends OidcAuth {

  loginResponse: Observable<LoginResponse>;

  constructor(private oidcSecurityService: OidcSecurityService, private configService: AppConfigService) {
    super();
  }

  login(credentials: any): Observable<boolean> {
    this.oidcSecurityService.authorize();
    return of(true);
  }

  logout(): Observable<boolean> {
    this.oidcSecurityService.logoff();
    localStorage.removeItem('pauth_token');
    this.loginResponse = null;
    return of(true);
  }

  validateAuth(): Observable<boolean> {
    if (!this.loginResponse) {
      this.loginResponse = this.oidcSecurityService.checkAuth();
    }
    return this.oidcSecurityService.checkAuth().pipe(
      exhaustMap(loginResponse => {
        this.getToken().subscribe(token => {
          localStorage.setItem('pauth_token', token);
        })
        return this.oidcSecurityService.isAuthenticated();
      }),
      shareReplay(1)
    );
  }

  getToken(): Observable<string> {
    const oidcConfig: any = this.configService.getConfig().loginConfig.loginTypes.filter(config => config.loginType === 'OIDC')[0];
    if (oidcConfig) {
      let token = '';
      switch (oidcConfig.tokenType) {
        default:
          return this.oidcSecurityService.getIdToken();
        case TokenType.idToken:
          return this.oidcSecurityService.getIdToken();
        case TokenType.accessToken:
          return this.oidcSecurityService.getAccessToken();
      }
      return of(undefined);
    }
  }
}
